import React from 'react';
import { Box, Typography } from '@mui/material';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import BasicTable from '@diditusa/shared/web_components/BasicTable/BasicTable';
import { useGetAgentJobsQuery } from '@diditusa/shared/api/agentApi';
import { Job, JobStatus } from '@diditusa/shared/types/jobTypes';
import { getErrorMessage } from '@diditusa/shared/api/apiUtils';
import { BasicTableHeader } from '@diditusa/shared/types/commonTypes';
const EmployeeJobs = () => {
  const { data: jobs, isLoading, isError, error: getJobsError } = useGetAgentJobsQuery();

  const renderJobs = () => {
    if (isLoading) {
      return <LoadingIndicator isVisible={isLoading} />;
    }

    if (isError) {
      return <p>Error loading jobs: {getErrorMessage(getJobsError)}</p>;
    }

    interface JobDetails {
      id: number;
      reservationCode: string;
      user: string;
      location: string;
      agents: string;
      startDate: Date;
      startTime: Date;
      duration: number;
      package: string;
      status: JobStatus;
    }

    type JobDetailsKey = keyof JobDetails;
    const jobDetails: JobDetails[] =
      jobs?.map(({ job: j }) => ({
        id: j.id,
        reservationCode: j.reservationCode,
        user: `${j.createdBy.firstName} ${j.createdBy.lastName}`,
        agents:
          j.jobAssignments?.map((ja) => `${ja.user.firstName} ${ja.user.lastName}`).join(',') || '',
        startTime: j.startTime,
        startDate: j.startTime,
        status: j.status,
        duration: j.durationHours,
        location: j.location,
        package: j.securityOption.title,
      })) || [];

    const headers: BasicTableHeader<JobDetailsKey>[] = [
      { key: 'reservationCode', value: 'Reservation Number' },
      { key: 'user', value: 'Customer' },
      { key: 'agents', value: 'Assigned Agent' },
      { key: 'location', value: 'Location' },
      { key: 'startDate', value: 'Start Date' },
      { key: 'startTime', value: 'Start Time' },
      { key: 'duration', value: 'Duration' },
      { key: 'package', value: 'Package' },
      { key: 'status', value: 'Status' },
    ];
    return (
      <Box sx={{ mb: 3 }}>
        <BasicTable headers={headers} data={jobDetails} />
      </Box>
    );
  };

  return (
    <Box minHeight='100vh' display='flex' flexDirection='row' bgcolor='white'>
      <Box flex={1} maxWidth={'90%'} mx='auto'>
        <Box
          display='flex'
          flexDirection={'row'}
          justifyContent='space-between'
          alignItems='center'
          p={2}
        >
          <Typography variant='h4' fontWeight={700} color='#111418'>
            Jobs assigned to me
          </Typography>
        </Box>
        {renderJobs()}
      </Box>
    </Box>
  );
};

export default EmployeeJobs;
